import { inject, makeEnvironmentProviders, type EnvironmentProviders } from '@angular/core';
import { SIGNALR_CONFIG } from '@ecam/eventq-components';
import { firstValueFrom } from 'rxjs';
import { AgentDataService } from './agent-data.service';

function appendLastEventId(url: string, lastId: string | null): string {
  if (!lastId) {
    return url;
  }
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}lastEventId=${encodeURIComponent(lastId)}`;
}

/** SIGNALR_CONFIG via AgentDataService negotiate (useFactory so inject() is legal). */
export function provideAgentSignalR(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SIGNALR_CONFIG,
      useFactory: () => {
        const agentData = inject(AgentDataService);
        return {
          lockName: 'signalr-leader',
          cursorStorageKey: 'lastEventId',
          negoatiateUrl: async (lastId: string | null) => {
            const negotiated = await firstValueFrom(agentData.signalrNegotiate());
            return {
              url: appendLastEventId(negotiated.url, lastId),
              accessToken: negotiated.accessToken,
            };
          },
        };
      },
    },
  ]);
}
